enum ActionTypes {
  GET_GLOBAL = '@REPORTS/GET_GLOBAL',
  GET_ALL = '@REPORTS/GET_ALL',
  GET_ROUNDS = '@REPORTS/GET_ROUNDS',
}

export default ActionTypes
